module.exports = __webpack_public_path__ + "member-birthday.svg?b216166af192bbb37d4bfd79ebbedaf3";